/* Accessibility bridge only: Judge.me keeps its native carousel and data. */
(() => {
  if (window.mamataReviewsAccessibility) return;
  window.mamataReviewsAccessibility = true;

  const selector = '.jdgm-carousel__left-arrow, .jdgm-carousel__right-arrow';
  const initialized = new WeakSet();

  const initialize = section => {
    section.querySelectorAll(selector).forEach(arrow => {
      if (initialized.has(arrow)) return;
      initialized.add(arrow);
      arrow.setAttribute('role', 'button');
      arrow.setAttribute('tabindex', '0');
      arrow.setAttribute('aria-label', arrow.classList.contains('jdgm-carousel__left-arrow')
        ? 'Recensioni precedenti' : 'Recensioni successive');
      // Map both activation keys to the same existing native click handler.
      arrow.addEventListener('keydown', event => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!event.repeat) arrow.click();
      }, true);
    });
  };

  const observeSection = section => {
    if (section.dataset.mamataReviewsObserved) return;
    section.dataset.mamataReviewsObserved = 'true';
    initialize(section);
    // The app may initialize or replace native controls after this asset loads.
    new MutationObserver(() => initialize(section)).observe(section, { childList: true, subtree: true });
  };

  const start = () => document.querySelectorAll('.mamata-reviews').forEach(observeSection);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
